import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from '@/router/index.js';
import '../src/css/main.css';
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faTasks, faHome, faUser, faUsers, faBuilding, faPhone, faSignInAlt, faQuestion,
  faRobot, faQuestionCircle, faMoneyBillWave, faChartLine, faPiggyBank,
  faCreditCard, faFileInvoiceDollar, faFileAlt, faBars, faCalendarAlt,
  faChevronLeft, faChevronRight, faEye, faEyeSlash, faMoon, faSun, faUserEdit
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import './registerServiceWorker'

axios.defaults.baseURL = 'https://backend.controlease.com.br/';

axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
  },
  error => Promise.reject(error)
);

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('usuario_id');
      localStorage.removeItem('role');
      router.push('/');
    }
    return Promise.reject(error);
  }
);

library.add(
  faHome, faUser, faUsers, faUserEdit, faBuilding, faPhone, faSignInAlt, faQuestion,
  faRobot, faQuestionCircle, faMoneyBillWave, faChartLine, faPiggyBank,
  faCreditCard, faFileInvoiceDollar, faFileAlt, faBars, faCalendarAlt,
  faChevronLeft, faChevronRight, faTasks, faEye, faEyeSlash, faMoon, faSun
);

const darkModePreference = localStorage.getItem('darkMode') === 'true';
if (darkModePreference) {
  document.documentElement.classList.add('dark');
}

const app = createApp(App);
app.use(createPinia());
app.component('font-awesome-icon', FontAwesomeIcon);
app.use(router);
app.mount('#app');